import { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export default function MiniSelect({ options, value, onChange, label, icon: Icon }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const selected = options.find(o => o.value === value);

  // Close on outside click
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center gap-1.5 px-2.5 py-1.5 bg-[var(--bg-elevated)] border border-[var(--border-subtle)] rounded-lg text-left hover:border-[var(--border-default)] transition-colors"
      >
        {Icon && <Icon size={11} className="text-[var(--text-muted)] flex-shrink-0" />}
        <span className="flex-1 text-[11px] text-[var(--text-primary)] truncate">{selected?.label || label}</span>
        <ChevronDown size={10} className={`text-[var(--text-muted)] transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="absolute z-50 mt-1 w-full max-h-44 overflow-y-auto bg-[var(--bg-elevated)] border border-[var(--border-default)] rounded-lg shadow-xl">
          {options.map(opt => (
            <button
              key={opt.value}
              onClick={() => { onChange(opt.value); setOpen(false); }}
              className={`w-full text-left px-2.5 py-1.5 text-[11px] hover:bg-[var(--bg-hover)] ${
                opt.value === value ? 'text-[var(--color-gold-400)] bg-[var(--color-gold-500)]/10' : 'text-[var(--text-primary)]'
              }`}
            >
              {opt.label}
              {opt.desc && <span className="block text-[9px] text-[var(--text-muted)]">{opt.desc}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
